export const L_COMPANY_TAX_SETTINGS = $.__('Company Tax Settings');
